import * as React from "react";

import { TextField, Autocomplete } from "mpulse-design-system";

const DropDownField = ({
  options,
  defaultValue,
  handleChange,
  label,
  disabled,
  helperText,
  error,
  dataTestId = "",
  reset,
}) => {
  return (
    <Autocomplete
      key={reset}
      disablePortal
      options={options}
      defaultValue={defaultValue}
      onChange={handleChange}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          helperText={helperText}
          error={error}
        />
      )}
      data-testid={dataTestId}
    />
  );
};

export default DropDownField;
